import { TEditorConfiguration } from "./documents/editor/core";

const NAV_BORDER_MARKER = "border-top:1px solid rgba(255,255,255,0.35)";

/** Adds a top border above the ComedyUO header nav row when present. */
export function patchHeaderNavBorder(
  contents: string | null | undefined
): string | null | undefined {
  if (!contents || contents.includes(NAV_BORDER_MARKER)) {
    return contents;
  }

  if (!contents.includes("Work With Us") && !contents.includes("work-with-us")) {
    return contents;
  }

  return contents.replace(
    /<tr><td><div style="text-align:center;padding-bottom:30px;">/g,
    `<tr><td style="${NAV_BORDER_MARKER};"><div style="text-align:center;padding-top:24px;padding-bottom:30px;">`
  );
}

export function patchDocumentHeaderNavBorders(
  doc: TEditorConfiguration
): TEditorConfiguration {
  let changed = false;
  const patched: TEditorConfiguration = { ...doc };

  for (const [id, block] of Object.entries(patched)) {
    if (block.type !== "Html" || !block.data?.props?.contents) {
      continue;
    }

    const contents = patchHeaderNavBorder(block.data.props.contents);
    if (!contents || contents === block.data.props.contents) {
      continue;
    }

    changed = true;
    patched[id] = {
      ...block,
      data: {
        ...block.data,
        props: {
          ...block.data.props,
          contents,
        },
      },
    };
  }

  return changed ? patched : doc;
}
